const IconThirdStep = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="104.239"
      height="89.792"
      viewBox="0 0 104.239 89.792"
    >
      <g id="undraw_credit_card_payments_re_qboh" transform="translate(24.364)">
        <path
          id="Trazado_626"
          data-name="Trazado 626"
          d="M91.6,28.505a4.289,4.289,0,0,1,3.035,2.844c.4,1.619-.518,3.252-.65,4.914-.427,5.448,7.323,9.291,6.217,14.642-.439,2.128-2.213,3.693-3.962,4.986-2.8,2.065-5.908,3.889-9.35,4.4-5.223.783-10.681-1.517-15.758-.064-4.095,1.173-7.228,4.61-11.3,5.878-3.1.966-6.431.585-9.647.194a10.161,10.161,0,0,1-4.95-1.494c-2.6-1.937-2.765-5.762-4.507-8.5-2.69-4.227-8.589-5.057-13.535-4.236S17.45,54.915,12.44,54.75a6.737,6.737,0,0,1-3.1-.707,7.7,7.7,0,0,1-2.582-2.877A46.547,46.547,0,0,1,.006,28.038a8.3,8.3,0,0,1,.681-4.107A7.506,7.506,0,0,1,4.85,20.8c3.988-1.517,8.393-1.766,12.3-3.477,3.769-1.651,6.821-4.546,10.1-7.027A53.814,53.814,0,0,1,49.418.42a14.051,14.051,0,0,1,5.714-.2,13.545,13.545,0,0,1,5.69,3.278c4.449,3.852,8.015,8.605,12.116,12.827a68.979,68.979,0,0,0,9.2,7.937,33.54,33.54,0,0,0,4.821,3.2C88.511,28.2,89.963,28.012,91.6,28.505Z"
          transform="translate(77.454 76.652) rotate(180)"
          fill="#85c440"
          opacity="0.2"
        />
        <path
          id="Trazado_560"
          data-name="Trazado 560"
          d="M445.973,333.981l12.37-6.432a78.964,78.964,0,0,1,6.763-6.641c2.609-2.066,3.412-.548,3.412-.548l1.1,1.828-2.65,3.686-7.159,6.062-12.791,5.01a2.028,2.028,0,1,1-1.041-2.965Z"
          transform="translate(-428.472 -304.205)"
          fill="#9f616a"
        />
        <path
          id="Trazado_561"
          data-name="Trazado 561"
          d="M345.164,343.458l.732-4.48,2.068-.517s1.641-.506,2.025,2.8a78.978,78.978,0,0,1,.086,9.478l4.2,13.3a2.033,2.033,0,1,1-2.832,1.36l-5.5-12.588Z"
          transform="translate(-295.488 -319.245)"
          fill="#9f616a"
        />
        <path
          id="Trazado_562"
          data-name="Trazado 562"
          d="M250.535,409.952h-2.706l-1.287-10.437h3.994Z"
          transform="translate(-217.963 -322.863)"
          fill="#9f616a"
        />
        <path
          id="Trazado_563"
          data-name="Trazado 563"
          d="M493.049,687.732H487.72a3.4,3.4,0,0,0-3.4,3.4v.111h8.725Z"
          transform="translate(-459.787 -601.526)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_564"
          data-name="Trazado 564"
          d="M96.707,409.952H94l-1.287-10.437h3.994Z"
          transform="translate(-34.621 -322.863)"
          fill="#9f616a"
        />
        <path
          id="Trazado_565"
          data-name="Trazado 565"
          d="M339.22,687.732h-5.329a3.4,3.4,0,0,0-3.4,3.4v.111h8.725Z"
          transform="translate(-276.444 -601.526)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_566"
          data-name="Trazado 566"
          d="M341.908,315.5l4.488,3.831-3.683,11.656-.831,2.6s5.075,4.679,8.215,17.75,8.277,30.438,8.277,30.438l-10.843,3.1-8.821-29.567-10.376,23.2-1.2,6.861-9.233-2.723,2.178-17.207,10.89-29.785-1.131-7.9a8.73,8.73,0,0,1,1.252-8.113l.926-3.921,3.316-.817Z"
          transform="translate(-293.181 -300.236)"
          fill="#85c440"
        />
        <path
          id="Trazado_567"
          data-name="Trazado 567"
          d="M375.371,251.6h12.134a.943.943,0,0,0,.941-.942v-5.23a7.009,7.009,0,1,0-14.017,0v5.23A.943.943,0,0,0,375.371,251.6Z"
          transform="translate(-334.1 -238.423)"
          fill="#2f2e41"
        />
        <ellipse
          id="Elipse_10"
          data-name="Elipse 10"
          cx="5.139"
          cy="5.139"
          rx="5.139"
          ry="5.139"
          transform="translate(43.854 14.894) rotate(-118.663)"
          fill="#9f616a"
        />
        <path
          id="Trazado_568"
          data-name="Trazado 568"
          d="M392.885,253.885h7.42l.076-1.065.38,1.065H401.9l.151-2.111.754,2.111h2.211v-.1a5.55,5.55,0,0,0-5.544-5.544h-1.046a5.55,5.55,0,0,0-5.544,5.544Z"
          transform="translate(-354.214 -246.354)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_569"
          data-name="Trazado 569"
          d="M388.9,270.287a.967.967,0,0,0,.167-.015l5.433-.959v-8.979h-5.981l.148.173c2.06,2.4.508,6.3-.6,8.407a.928.928,0,0,0,.074.985A.938.938,0,0,0,388.9,270.287Z"
          transform="translate(-342.744 -256.13)"
          fill="#2f2e41"
        />
        <path
          id="Trazado_570"
          data-name="Trazado 570"
          d="M330.936,421.592l47.617,16.835a4.713,4.713,0,0,0,6.008-2.869l8.18-23.136a4.713,4.713,0,0,0-2.869-6.008l-47.617-16.835a4.713,4.713,0,0,0-6.008,2.869l-8.18,23.136A4.714,4.714,0,0,0,330.936,421.592Z"
          transform="translate(-329.716 -360.36)"
          fill="#fff"
        />
        <path
          id="Trazado_571"
          data-name="Trazado 571"
          d="M372.977,526.253l-.043.122a4.5,4.5,0,0,0,2.741,5.737l47.855,16.92a4.5,4.5,0,0,0,5.737-2.74l.043-.122Z"
          transform="translate(-374.626 -471.029)"
          fill="#f2f2f2"
        />
        <path
          id="Trazado_572"
          data-name="Trazado 572"
          d="M342.753,494.955a6.432,6.432,0,0,0,8.616-1.763l-.226-.128A6.412,6.412,0,0,0,342.753,494.955Z"
          transform="translate(-290.945 -443.529)"
          fill="#85c440"
        />
        <path
          id="Trazado_573"
          data-name="Trazado 573"
          d="M575.2,487.92a2.583,2.583,0,0,0,2.068-.037c1.355-.673,1.991-2.67,2.5-4.274.149-.467.289-.907.432-1.268l0-.005a2.873,2.873,0,0,0-1.741-3.648l-6.4-2.265a2.582,2.582,0,0,0-2.066.037c-1.355.672-1.991,2.668-2.5,4.272-.149.468-.29.909-.433,1.27a2.875,2.875,0,0,0,1.74,3.654Zm4.735-5.681c-.146.369-.288.813-.438,1.284-.495,1.553-1.11,3.485-2.357,4.1a2.28,2.28,0,0,1-1.846.024l-6.4-2.264a2.588,2.588,0,0,1-1.569-3.285c.145-.365.287-.811.438-1.283.495-1.552,1.111-3.484,2.358-4.1a2.279,2.279,0,0,1,1.843-.024l6.4,2.264A2.587,2.587,0,0,1,579.937,482.238Z"
          transform="translate(-562.947 -430.602)"
          fill="#3f3d56"
        />
        <path
          id="Trazado_574"
          data-name="Trazado 574"
          d="M342.574,495.049a6.648,6.648,0,0,0,7.517-2.45l.078-.126-.352-.2a6.562,6.562,0,0,0-8.583,1.934l-.077.119.119.078A5.993,5.993,0,0,0,342.574,495.049Zm7.194-2.476a6.205,6.205,0,0,1-3.755,2.39,5.947,5.947,0,0,1-4.459-.72,6.271,6.271,0,0,1,8.115-1.727Z"
          transform="translate(-289.439 -442.876)"
          fill="#3f3d56"
        />
        <path
          id="Trazado_575"
          data-name="Trazado 575"
          d="M381.923,562.452a2.368,2.368,0,0,0,2.408-.4,2.962,2.962,0,0,0,.969-2.738,2.377,2.377,0,0,0-1.669-1.843l-8.534-3.017a2.381,2.381,0,0,0-2.454.386,2.962,2.962,0,0,0-.968,2.738,2.387,2.387,0,0,0,1.669,1.84l8.534,3.017Zm1.655-4.7a2.1,2.1,0,0,1,1.442,1.612,2.668,2.668,0,0,1-.873,2.467,2.1,2.1,0,0,1-2.171.333l-8.538-3.019a2.1,2.1,0,0,1-1.482-1.624,2.668,2.668,0,0,1,.872-2.467,2.108,2.108,0,0,1,2.173-.336l8.539,3.019Z"
          transform="translate(-330.461 -493.673)"
          fill="#3f3d56"
        />
        <path
          id="Trazado_576"
          data-name="Trazado 576"
          d="M575.605,495.85l2.69.951a.713.713,0,1,0,.476-1.345l-2.69-.951a.713.713,0,1,0-.476,1.345Z"
          transform="translate(-563.407 -445.339)"
          fill="#85c440"
        />
        <path
          id="Trazado_577"
          data-name="Trazado 577"
          d="M579.571,507.067l2.69.951a.713.713,0,1,0,.476-1.345l-2.69-.951a.713.713,0,1,0-.476,1.345Z"
          transform="translate(-568.134 -454.404)"
          fill="#85c440"
        />
        <path
          id="Trazado_578"
          data-name="Trazado 578"
          d="M583.537,518.285l2.69.951a.713.713,0,1,0,.475-1.345l-2.69-.951a.713.713,0,1,0-.476,1.345Z"
          transform="translate(-572.861 -463.469)"
          fill="#85c440"
        />
        <path
          id="Trazado_579"
          data-name="Trazado 579"
          d="M600.143,487.174l2.69.951a.713.713,0,1,0,.476-1.345l-2.69-.951a.713.713,0,1,0-.476,1.345Z"
          transform="translate(-592.652 -438.328)"
          fill="#85c440"
        />
        <path
          id="Trazado_580"
          data-name="Trazado 580"
          d="M604.109,498.392l2.69.951a.713.713,0,0,0,.476-1.345l-2.69-.951a.713.713,0,0,0-.476,1.345Z"
          transform="translate(-597.379 -447.393)"
          fill="#85c440"
        />
        <path
          id="Trazado_581"
          data-name="Trazado 581"
          d="M608.075,509.609l2.69.951a.713.713,0,0,0,.476-1.345l-2.69-.951a.713.713,0,1,0-.476,1.345Z"
          transform="translate(-602.106 -456.458)"
          fill="#85c440"
        />
        <rect
          id="Rectángulo_242"
          data-name="Rectángulo 242"
          width="59.75"
          height="0.285"
          transform="matrix(-0.943, -0.333, 0.333, -0.943, 60.987, 57.311)"
          fill="#3f3d56"
        />
        <path
          id="Trazado_582"
          data-name="Trazado 582"
          d="M330.936,421.592l47.617,16.835a4.713,4.713,0,0,0,6.008-2.869l8.18-23.136a4.713,4.713,0,0,0-2.869-6.008l-47.617-16.835a4.713,4.713,0,0,0-6.008,2.869l-8.18,23.136A4.714,4.714,0,0,0,330.936,421.592Zm58.84-14.909a4.428,4.428,0,0,1,2.7,5.644l-8.18,23.136a4.428,4.428,0,0,1-5.644,2.7l-47.617-16.835a4.428,4.428,0,0,1-2.7-5.644l8.18-23.136a4.428,4.428,0,0,1,5.644-2.7Z"
          transform="translate(-329.716 -360.36)"
          fill="#3f3d56"
        />
        <path
          id="Trazado_583"
          data-name="Trazado 583"
          d="M241.517,704.806H345.474c.078,0,.141-.086.141-.192s-.063-.192-.141-.192H241.517c-.078,0-.141.086-.141.192S241.44,704.806,241.517,704.806Z"
          transform="translate(-265.74 -615.015)"
          fill="#cbcbcb"
        />
        <g id="Grupo_139" data-name="Grupo 139" transform="translate(-22.037 57.514)">
          <path
            id="Trazado_555"
            data-name="Trazado 555"
            d="M804.618,576.746l-.365-.007a84.686,84.686,0,0,1,1.3-12.107c1.58-8.563,4.206-14.186,7.807-16.714l.21.3C805.155,554.122,804.622,576.521,804.618,576.746Z"
            transform="translate(-804.252 -544.597)"
            fill="#2f2e41"
          />
          <path
            id="Trazado_556"
            data-name="Trazado 556"
            d="M807.618,648.977l-.365-.007c.008-.4.236-9.939,3.99-12.574l.21.3C807.85,639.224,807.619,648.88,807.618,648.977Z"
            transform="translate(-802.686 -616.914)"
            fill="#2f2e41"
          />
          <ellipse
            id="Elipse_8"
            data-name="Elipse 8"
            cx="1.826"
            cy="1.826"
            rx="1.826"
            ry="1.826"
            transform="translate(9.565)"
            fill="#85c440"
          />
          <ellipse
            id="Elipse_9"
            data-name="Elipse 9"
            cx="1.826"
            cy="1.826"
            rx="1.826"
            ry="1.826"
            transform="translate(8.661 15.708)"
            fill="#85c440"
          />
          <path
            id="Trazado_557"
            data-name="Trazado 557"
            d="M834.9,538.787a8.114,8.114,0,0,1-.552,4.154,7.394,7.394,0,0,1-1.243-7.94A8.115,8.115,0,0,1,834.9,538.787Z"
            transform="translate(-830.82 -534.039)"
            fill="#2f2e41"
          />
          <path
            id="Trazado_558"
            data-name="Trazado 558"
            d="M785.7,573.157a8.114,8.114,0,0,1-4.186.181,7.394,7.394,0,0,1,7.6-2.608A8.112,8.112,0,0,1,785.7,573.157Z"
            transform="translate(-775.653 -563.084)"
            fill="#2f2e41"
          />
          <path
            id="Trazado_559"
            data-name="Trazado 559"
            d="M789.675,652.745a5.687,5.687,0,0,1-2.934.127,5.182,5.182,0,0,1,5.328-1.828A5.687,5.687,0,0,1,789.675,652.745Z"
            transform="translate(-779.557 -628.761)"
            fill="#2f2e41"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconThirdStep;
